import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getService() {
  const data = await axiosInstance({
    url: "/service",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createService(formData) {
  const data = await axiosInstance({
    url: "/service",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateService(formData) {
  const data = await axiosInstance({
    url: `/service/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteService(formData) {
  const data = await axiosInstance({
    url: `/service/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useService() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.service],
    queryFn: getService,
  });
  return data;
}

export function useUpdateService() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateService(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.service]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddService() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createService(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.service]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeleteService() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteService(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.service]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
